import React, { useState } from "react";
import { Form, Select, InputNumber } from "formik-antd";
import SelectWithDescription from "../../../core/components/form/selectWithDescription";

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

const initialCategoryList = (props) => {
    if ((props.formik.values.services || []).length === 0) {
        return [];
    }

    const current = props.formik.values.services;

    const services = props.services.filter((item) => current.indexOf(item?.id) !== -1);

    const categoriesIds = services.reduce(
        (a, currentValue) => [...a, ...(currentValue.categories || []).map((item) => item.id)],
        []
    );

    const categories = props.categories.filter((item) => categoriesIds.indexOf(item?.id) !== -1);

    return categories;
};
const initialSpecializationList = (props) => {
    if ((props.formik.values.services || []).length === 0) {
        return [];
    }

    const current = props.formik.values.services;

    return props.specializations.filter((item) => {
        if ((item.services || []).length > 0) {
            return (item.services || []).some((s) => current.indexOf(s?.id) !== -1);
        }
        return true;
    });
};

const Subform = (props) => {
    const [listOfCategories, setListOfCategories] = useState(initialCategoryList(props));
    const [listOfSpecializations, setListOfSpecializations] = useState(initialSpecializationList(props));

    const changeServices = (current, values, setFieldValue) => {
        if ((current || []).length === 0) {
            setListOfSpecializations([]);
            return;
        }

        const services = props.services.filter((item) => current.indexOf(item?.id) !== -1);

        const categoriesIds = services.reduce(
            (a, currentValue) => [...a, ...(currentValue.categories || []).map((item) => item.id)],
            []
        );

        const categories = props.categories.filter((item) => categoriesIds.indexOf(item?.id) !== -1);
        setListOfCategories(categories);

        const specializations = props.specializations.filter((item) => {
            if ((item.services || []).length > 0) {
                return (item.services || []).some((s) => current.indexOf(s?.id) !== -1);
            }
            return true;
        });

        setListOfSpecializations(specializations);
    };

    const hideLanguagePairBasedOnServices = (values) => {
        const services = (props.services || []).filter((s) => {
            return (values.services || []).indexOf(s?.id) !== -1;
        });

        return services.some((item) => item.language == "Pair");
    };

    const hideLanguageBasedOnServices = (values) => {
        const services = (props.services || []).filter((s) => {
            return (values.services || []).indexOf(s?.id) !== -1;
        });

        return services.some((item) => item.language == "Single");
    };

    const { values, errors, setFieldValue } = props.formik;
    return (
        <>
            <Form.Item label="Services" name="services" showValidateSuccess={true} hasFeedback={true} required>
                <SelectWithDescription
                    name="services"
                    style={{ width: "100%" }}
                    placeholder="Select multiple"
                    mode="multiple"
                    options={props.services}
                    filterOption={_filter}
                    onChange={(val) => changeServices(val, values, setFieldValue)}
                />
            </Form.Item>

            {(listOfCategories || []).length > 0 && (
                <Form.Item label="Categories" name="categories">
                    <SelectWithDescription
                        name="categories"
                        style={{ width: "100%" }}
                        placeholder="Select multiple"
                        mode="multiple"
                        options={listOfCategories}
                        filterOption={_filter}
                    />
                </Form.Item>
            )}

            {hideLanguageBasedOnServices(values) && (
                <Form.Item label="Language Family" name="language_family">
                    <Select
                        name="language_family"
                        style={{ width: "100%" }}
                        placeholder="Language Family"
                        showSearch
                        allowClear
                    >
                        <Select.Option value=""></Select.Option>
                        <Select.Option value="LTR">LTR</Select.Option>
                        <Select.Option value="RTL">RTL</Select.Option>
                        <Select.Option value="BOTH">BOTH</Select.Option>
                    </Select>
                </Form.Item>
            )}

            {hideLanguageBasedOnServices(values) && (
                <Form.Item label="Language" name="languages">
                    <Select
                        name="languages"
                        style={{ width: "100%" }}
                        placeholder="Select multiple"
                        mode="multiple"
                        options={props.languages}
                        filterOption={_filter}
                    />
                </Form.Item>
            )}

            {hideLanguagePairBasedOnServices(values) && (
                <Form.Item label="Language Pairs" name="language_pairs">
                    <Select
                        name="language_pairs"
                        style={{ width: "100%" }}
                        placeholder="Select multiple"
                        mode="multiple"
                        options={props.languagePairs}
                        filterOption={_filter}
                    />
                </Form.Item>
            )}

            <Form.Item label="Specialization" name="specializations">
                <Select
                    name="specializations"
                    style={{ width: "100%" }}
                    placeholder="Select multiple"
                    mode="multiple"
                    options={listOfSpecializations}
                    filterOption={_filter}
                />
            </Form.Item>
        </>
    );
};
export default Subform;
